/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_New_PasswordInputs */

const cs_settings_profile_new_password = /** @type {(inputs: Settings_Profile_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nové heslo`)
};

const en_settings_profile_new_password = /** @type {(inputs: Settings_Profile_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New password`)
};

/**
* | output |
* | --- |
* | "New password" |
*
* @param {Settings_Profile_New_PasswordInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_new_password = /** @type {((inputs?: Settings_Profile_New_PasswordInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_New_PasswordInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_new_password(inputs)
	return cs_settings_profile_new_password(inputs)
});